export const CatalogAnalyticsApi = {
  // GET
  getAnalytics: '/analytics',
  // POST
  createAnalytic: '/analytics/create',
  // PUT
  updateAnalytic: '/analytics/update/:id',
  // DELETE
  deleteAnalytics: '/analytics/bulk/delete'
};

export const ProductMatchAnalyticsApi = {
  // GET
  getAnalytic: '/product-match-analytics',
  // POST
  createAnalytic: '/product-match-analytics/create',
  // PUT
  updateAnalytic: '/product-match-analytics/update/:id',
  // DELETE
  deleteAnalytics: '/product-match-analytics/bulk/delete'
};

export const RfqAnalyticsApi = {
  // GET
  getAnalytic: '/rfq-analytics',
  // POST
  createAnalytic: '/rfq-analytics/create',
  // PUT
  updateAnalytic: '/rfq-analytics/update/{id}',
  // DELETE
  deleteAnalytics: '/rfq-analytics/bulk/delete'
};

export const SalesEnablementAnalyticsApi = {
  // GET
  getAnalytic: '/sales-enablement-analytics',
  // POST
  createAnalytic: '/sales-enablement-analytics/create',
  // PUT
  updateAnalytic: '/sales-enablement-analytics/update/{id}',
  // DELETE
  deleteAnalytics: '/sales-enablement-analytics/bulk/delete'
};
